import { Text } from '@ekhodealer/ekho-common/rev';

interface OrderDateCellProps {
	date?: string;
}

export const OrderDateCell = ({ date }: OrderDateCellProps) => {
	const displayText = date || '—';

	return (
		<div style={{ minWidth: '160px' }}>
			<Text size='bodySmall'>{displayText}</Text>
		</div>
	);
};
